<div class="mb-2 font-semibold text-black">1. What is Travel Protect Plus?</div>

<div>
    Travel Protect Plus is an affordable, <b>comprehensive travel insurance</b> plan for individuals traveling within Malaysia or
    intentionally for business or leisure. <br /><br />
    It provides protection in case of accident, medical issues, or trip disruptions.
</div>

<hr class="my-4" />

<div class="mb-2 font-semibold text-black">2. What does Travel Protect Plus cover?</div>

<div class="table-card text-xs">
    <div class="flex items-center gap-4 bg-[#0064DC] p-3.5 text-center text-sm font-bold text-white">
        <div class="flex-1">Benefits</div>
        <div class="flex-1">Domestic</div>
        <div class="flex-1">Overseas (Asia & Worldwide)</div>
    </div>

    <div class="bg-[#EBF6FF] py-1.5 text-center">Personal Accident</div>
    <div class="flex items-center gap-4 p-2">
        <div class="flex-1 text-[#101828]">Accidental Death</div>
        <div class="flex-1 text-[#475467]">RM 50,000</div>
        <div class="flex-1 text-[#475467]">RM 100,000</div>
    </div>
    <div class="flex items-center gap-4 p-2">
        <div class="flex-1 text-[#101828]">Permanent Disablement</div>
        <div class="flex-1 text-[#475467]">Up to RM 50,000</div>
        <div class="flex-1 text-[#475467]">Up to RM 100,000</div>
    </div>

    <div class="bg-[#EBF6FF] py-1.5 text-center">Medical Benefits</div>
    <div class="flex items-center gap-4 p-2">
        <div class="flex-1 text-[#101828]">Medical Expenses</div>
        <div class="flex-1 text-[#475467]">Up to RM 15,000</div>
        <div class="flex-1 text-[#475467]">Up to RM 100,000</div>
    </div>
    <div class="flex items-center gap-4 p-2">
        <div class="flex-1 text-[#101828]">Hospital Income</div>
        <div class="flex-1 text-[#475467]">
            RM 100/day
            <div class="text-[10px]">(max RM 3,000)</div>
        </div>
        <div class="flex-1 text-[#475467]">
            RM 450/day
            <div class="text-[10px]">(max RM 15,000)</div>
        </div>
    </div>

    <div class="bg-[#EBF6FF] py-1.5 text-center">Travel Inconvenience Benefits</div>
    <div class="flex items-center gap-4 p-2">
        <div class="flex-1 text-[#101828]">Trip Cancellation / Curtailment</div>
        <div class="flex-1 text-[#475467]">Up to RM 1,000</div>
        <div class="flex-1 text-[#475467]">Up to RM 5,000</div>
    </div>
    <div class="flex items-center gap-4 p-2">
        <div class="flex-1 text-[#101828]">Personal Luggage / Effects</div>
        <div class="flex-1 text-[#475467]">Up to RM 500</div>
        <div class="flex-1 text-[#475467]">Up to RM 5,000</div>
    </div>
    <div class="flex items-center gap-4 p-2">
        <div class="flex-1 text-[#101828]">Luggage Delay</div>
        <div class="flex-1 text-[#475467]">
            RM 100
            <div class="text-[10px]">(min 6 hours)</div>
        </div>
        <div class="flex-1 text-[#475467]">
            RM 200 per 6 hours
            <div class="text-[10px]">(max RM 800)</div>
        </div>
    </div>
    <div class="flex items-center gap-4 p-2">
        <div class="flex-1 text-[#101828]">Travel Delay</div>
        <div class="flex-1 text-[#475467]">
            RM 100 per 6 hours
            <div class="text-[10px]">(max RM 1,500)</div>
        </div>
        <div class="flex-1 text-[#475467]">
            RM 200 per 6 hours
            <div class="text-[10px]">(max RM 2,000)</div>
        </div>
    </div>
</div>

<hr class="my-4" />

<div class="mb-2 font-semibold text-black">3. Who is eligible for Travel Protect Plus?</div>
<div class="mb-4">You are eligible if you are:</div>
<div class="mb-4 pl-6">
    <ul class="list-outside list-disc">
        <li>A <b>CelcomDigi postpaid customer</b></li>
        <li>Aged between <b>18 and 60 years</b> (at the time of application or renewal)</li>
        <li>A Malaysian citizen, permanent resident, or legally employed foreigner residing in Malaysia</li>
        <li>The <b>Main Account Holder</b> or <b>Principal Line Holder</b> with CelcomDigi</li>
    </ul>
</div>

<div class="pt-4">
    @if (address.includes("gethelp")) {
        <a routerLink="policy-faq-full-travel">Click here for more FAQs</a>    
    }
    @else {
        <a routerLink="policy-faq-full">Click here for more FAQs</a>
    }
</div>
